<script setup>
defineProps({
  error: {
    type: Object,
    required: true,
  },
})
</script>

<template>
  <div class="flex flex-col items-center justify-center gap-6 h-screen">
    <TarcLogoBackground />
    <h1 class="text-2xl font-bold">
      Uh oh! Something went wrong.
    </h1>
    <p>{{ error.message }}</p>
    <div class="flex gap-2">
      <UButton
        variant="soft"
        size="sm"
        to="/"
      >
        Go home
      </UButton>
      <UButton
        size="sm"
        to="https://auth.tarc.ltd/sign-in"
        external
        trailing-icon="lucide:arrow-right"
      >
        Go to sign in
      </UButton>
    </div>
  </div>
</template>
